/**
 * IMPORTS
 */

// data / dtos / response-api / users / post-create-client-complet-response-api
import { ICreateClientResponse } from "@/data/dtos/response-api/users/post-create-client-complet-response-api";
import { ICreateClientPayload } from "@/data/dtos/users/post-create-client-complet-dto";
// data / http / axios / axios-client
import { axiosClient } from "@/data/http/axios/axios-client";
// domain / repositories / users / post-create-client-complet-repository-contract
import { IPostCreateClientCompletRepository } from "@/domain/repositories/users/post-create-client-complet-repository-contract";

/**
 * Implementação responsável por consumir
 * a API de criação de cliente completo.
 */
class PostCreateClientCompletRepositoryImplementation implements IPostCreateClientCompletRepository {
  async createClientComplet(payload: ICreateClientPayload): Promise<ICreateClientResponse> {
    const response = await axiosClient<ICreateClientResponse>(`users/cliente-completo`, {
      method: "post",
      data: payload,
    });

    return response;
  }
}

/**
 * EXPORTS
 */
export { PostCreateClientCompletRepositoryImplementation };
